import { getContratoTimbradoUrl } from './contratoVendaConfig';

let cachedDataUrl: string | null = null;

/**
 * Carrega o timbrado como data URL (base64) para @react-pdf e impressão confiável.
 * O react-pdf frequentemente falha com URLs relativas ou fetch assíncrono durante o render.
 */
export async function loadTimbradoAsDataUrl(): Promise<string> {
  if (cachedDataUrl) return cachedDataUrl;

  const url = getContratoTimbradoUrl();
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Não foi possível carregar o timbrado (${response.status})`);
  }

  const blob = await response.blob();
  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(new Error('Falha ao ler imagem do timbrado'));
    reader.readAsDataURL(blob);
  });

  cachedDataUrl = dataUrl;
  return dataUrl;
}
